import { State, Action, StateContext, Selector } from '@ngxs/store';
import { IProvider } from '../../../core/modules/admin-modules/contract/contracts/models/contracts.model';
import { PatchProviderList } from './provider.actions';

interface ProviderStateModel {
  providers: IProvider[] | null;
}

@State<ProviderStateModel>({
  name: 'provider',
  defaults: {
    providers: null
  }
})
export class ProviderState {

  @Selector()
  static providers(state: ProviderStateModel) {
    return state?.providers;
  }

  @Action(PatchProviderList)
  patchProviderList(ctx: StateContext<ProviderStateModel>, action: PatchProviderList) {
    ctx.patchState({
      providers: action.payload
    });
  }
}